import { useAuctionContext } from '../../../../context/AuctionContext';
import React from 'react';
import { AuctionReduceBetModal } from '../../../../components/AuctionReduceBetModal';

export function AuctionReduceBetModalContainer() {
  const { isAuctionEnabled, isReducingBet, incrementBet, currentBet, formik, resetForm } = useAuctionContext();

  const [open, setOpen] = React.useState(isReducingBet);

  const handleClose = React.useCallback(() => {
    setOpen(false);
    resetForm();
  }, [resetForm]);

  React.useEffect(() => {
    if (isReducingBet) {
      setOpen(true);
    }
  }, [isReducingBet]);

  if (!isAuctionEnabled) {
    return null;
  }

  return (
    <AuctionReduceBetModal
      open={open}
      onClose={handleClose}
      incrementBet={incrementBet}
      formik={formik}
      currentBet={currentBet}
    />
  );
}
